import { post } from "./base";
import { MAIN_SERVICE_URL } from "../utils/constant";

const MainService = {
    calculate: (param) => post(MAIN_SERVICE_URL.CALCULATE, param)
};

export default MainService;